<template>
  <div id="bd-thread">
    <el-table
      :data="historyThreads.content"
      style="width: 100%; height: 100%; overflow: scroll;">
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="visitor.nickname" label="访客昵称"></el-table-column>
      <el-table-column prop="createdAt" label="进入时间"></el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleView(scope.$index, scope.row)">{{ $t('messageHistory') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="float: right; margin-top: 10px;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 100, 200, 300, 400]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="historyThreads.totalElements">
    </el-pagination>
    <el-button @click="getThreads" size="mini" style="margin-top: 12px;">{{ $t('refresh') }}</el-button>
    <el-drawer
      :title="messageHistoryTip"
      :visible.sync="messageDrawerVisible"
      :direction="drawerDirection"
      :before-close="handleDrawerClose"
      size="50%">
      <cm-message :viewThreadTid="viewThreadTid"></cm-message>
    </el-drawer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CmMessage from '@/components/common/CmMessage'

export default {
  name: 'bd-thread',
  data () {
    return {
      messageDrawerVisible: false,
      drawerDirection: 'rtl',
      viewThreadTid: '',
      pageSize: 10,
      currentPage: 1
    }
  },
  components: { CmMessage },
  computed: {
    ...mapGetters([ 'historyThreads', 'userCurrentThread', 'showAuthority' ]),
    messageHistoryTip () {
      return this.$t('messageHistory')
    }
  },
  // watch: {
  //   userCurrentThread (newThread, oldThread) {
  //     this.getThreads()
  //   }
  // },
  methods: {
    ...mapActions([ 'getHistoryThreads' ]),
    getThreads () {
      let params = { page: this.currentPage - 1, size: this.pageSize, uid: this.userCurrentThread.uid }
      // console.log('params:', params)
      this.getHistoryThreads(params)
    },
    handleSizeChange (val) {
      console.log(val)
      this.pageSize = val
      //
      this.getThreads()
    },
    handleCurrentChange (val) {
      console.log(val)
      this.currentPage = val
      //
      this.getThreads()
    },
    handleView (index, row) {
      // console.log(index, row)
      this.viewThreadTid = row.tid
      this.messageDrawerVisible = true
    },
    handleDrawerClose (done) {
      done()
    }
  },
  mounted () {
    // this.getThreads()
  }
}
</script>

<style scoped>
#bd-thread {
  width: 100%;
  height: 100%;
}
</style>
